export const vlozMock = [[
{
    "isSuccess": true,
    "data": [
        [
            {
                "id": 529,
                "basesVloz": [
                    {
                        "id": 1,
                        "cards": {
                            "clientesCadastrados": 42,
                            "novosClientes": 0,
                            "tpv": 0,
                            "split": 0
                        }
                    },
                    {
                        "id": 2,
                        "cardsMesPassado": {
                            "clientesCadastrados": 49,
                            "novosClientes": 0,
                            "tpv": 0,
                            "split": 0
                        }
                    },
                    {
                        "id": 3,
                        "clientesTransVloz": [
                            {
                                "clientes": 47,
                                "inicioMes": "2025-09-01T00:00:00"
                            },
                            {
                                "clientes": 42,
                                "inicioMes": "2026-05-01T00:00:00"
                            },
                            {
                                "clientes": 50,
                                "inicioMes": "2025-06-01T00:00:00"
                            },
                            {
                                "clientes": 47,
                                "inicioMes": "2025-10-01T00:00:00"
                            },
                            {
                                "clientes": 49,
                                "inicioMes": "2026-04-01T00:00:00"
                            },
                            {
                                "clientes": 49,
                                "inicioMes": "2026-03-01T00:00:00"
                            },
                            {
                                "clientes": 52,
                                "inicioMes": "2025-07-01T00:00:00"
                            },
                            {
                                "clientes": 52,
                                "inicioMes": "2026-02-01T00:00:00"
                            },
                            {
                                "clientes": 46,
                                "inicioMes": "2026-01-01T00:00:00"
                            },
                            {
                                "clientes": 49,
                                "inicioMes": "2025-11-01T00:00:00"
                            },
                            {
                                "clientes": 48,
                                "inicioMes": "2025-08-01T00:00:00"
                            },
                            {
                                "clientes": 44,
                                "inicioMes": "2025-12-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": 4,
                        "novosCadastrosVloz": []
                    },
                    {
                        "id": 5,
                        "createdAt": "2026-05-14T17:50:33.2944151"
                    }
                ],
                "codigoVendedor": "00247241",
                "nomeVendedor": "LUCAS TIEGHI"
            },
            {
                "id": 1558,
                "basesVloz": [
                    {
                        "id": 1,
                        "cards": {
                            "clientesCadastrados": 91,
                            "novosClientes": 0,
                            "tpv": 302609.2,
                            "split": 51329.86
                        }
                    },
                    {
                        "id": 2,
                        "cardsMesPassado": {
                            "clientesCadastrados": 119,
                            "novosClientes": 0,
                            "tpv": 840825.1300000001,
                            "split": 142633.93000000005
                        }
                    },
                    {
                        "id": 3,
                        "clientesTransVloz": [
                            {
                                "clientes": 117,
                                "inicioMes": "2025-12-01T00:00:00"
                            },
                            {
                                "clientes": 119,
                                "inicioMes": "2026-04-01T00:00:00"
                            },
                            {
                                "clientes": 129,
                                "inicioMes": "2025-11-01T00:00:00"
                            },
                            {
                                "clientes": 91,
                                "inicioMes": "2026-05-01T00:00:00"
                            },
                            {
                                "clientes": 127,
                                "inicioMes": "2025-09-01T00:00:00"
                            },
                            {
                                "clientes": 112,
                                "inicioMes": "2025-10-01T00:00:00"
                            },
                            {
                                "clientes": 117,
                                "inicioMes": "2025-06-01T00:00:00"
                            },
                            {
                                "clientes": 126,
                                "inicioMes": "2026-01-01T00:00:00"
                            },
                            {
                                "clientes": 124,
                                "inicioMes": "2026-02-01T00:00:00"
                            },
                            {
                                "clientes": 130,
                                "inicioMes": "2025-07-01T00:00:00"
                            },
                            {
                                "clientes": 127,
                                "inicioMes": "2025-08-01T00:00:00"
                            },
                            {
                                "clientes": 131,
                                "inicioMes": "2026-03-01T00:00:00"
                            },
                            {
                                "clientes": 49,
                                "inicioMes": "2025-05-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": 4,
                        "novosCadastrosVloz": [
                            {
                                "quantidade": 13,
                                "inicioMes": "2025-08-01T00:00:00"
                            },
                            {
                                "quantidade": 0,
                                "inicioMes": "2025-12-01T00:00:00"
                            }
                        ]
                    },
                    {
                        "id": 5,
                        "createdAt": "2026-05-14T17:50:33.2944151"
                    }
                ],
                "codigoVendedor": "277574",
                "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
            }
        ]
    ],
    "existentes": []
}
]]